import { useQuery } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";

import { readUser, readUserPhotoBlobUrl, readUsers } from "../services/userApi";

export function useUserQuery(id, isOpen) {
  const { t } = useTranslation();

  return useQuery({
    queryKey: ["users", id],
    queryFn: () => readUser(id),
    enabled: isOpen && !!id,
    gcTime: 0,
    onError: (error) => {
      toast.error(error.message || t("item.messages.fetchError"));
    },
  });
}

export function useUserPhotoBlobUrlQuery(public_id, enabled, onSuccess) {
  return useQuery({
    queryKey: ["userPhoto", public_id],
    queryFn: () => readUserPhotoBlobUrl(public_id),
    enabled: enabled && !!public_id,
    gcTime: 0,
    onError: (error) => {
      toast.error(error.message || "Failed to load user photo");
    },
    onSuccess: onSuccess,
  });
}

export function useUsersQuery() {
  return useQuery({
    queryKey: ["users"],
    queryFn: () => readUsers(),
  });
}
